import axios from "axios";
import * as _f_ from "./funciones";
import Respuesta from "./funciones";
// const host = "http://localhost:8000/";
// const host = "http://192.168.18.29:8000/";
// const host = "http://192.168.18.53:8000/"; /7sanmiguel
// // const host = "http://172.28.119.201:8000/";
// const host = 'http://192.168.18.42:8000/'
const host = "https://api.panificadorasanmiguel.com/";

export const debug = console.log;
//172.28.119.201
function crearPeticion(params = {}) {
  const usuario = _f_.obtenerCookie("usuario");
  const tokenSesion = _f_.obtenerCookie("tokenSesion");
  let informacionServidor = { usuario, tokenSesion };
  return {
    SMServInfo: informacionServidor,
    ...params,
  };
}

function llamarApi({ endpoint, peticion, origen = "", timeout = 5000 }) {
  timeout = 30000;
  const controlLlamado = new AbortController();
  const url = `${host}${endpoint}/`;
  const configuracion = {
    timeout,
    signal: controlLlamado.signal,
    headers: {
      "Content-type": "application/json",
    },
  };
  async function llamado() {
    const tiempoInicio = Date.now();

    try {
      const respuesta = await axios.post(url, peticion, configuracion);
      const validacion = _f_.validarLLamadoApi({ respuesta, endpoint, origen });
      return validacion;
    } catch (error) {
      const tiempoFin = Date.now();
      const tiempoTomado = `${(tiempoFin - tiempoInicio) / 1000}s`;
      let mensajeError;
      switch (true) {
        case axios.isCancel(error):
          mensajeError = "Peticion cancelada"; //new Error(`Petición cancelada ${tiempoTomado}`);
          break;

        case error.code === "ECONNABORTED":
          mensajeError = new Error(`La solicitud tardo más de los esperado ${tiempoTomado}`);
          break;

        case !!error.response:
          const status = error.response.status; // ej. 400, 404, 500
          const detalleServidor = error.response.data?.error || "Error no especificado";
          mensajeError = new Error(
            `Error por excepción dentro del servicio: ${detalleServidor}, ${status} ${tiempoTomado}`,
          );
          break;

        case !error.response && error.request && error.message === "Network Error":
          mensajeError = new Error(`Error de red o sin internet ${tiempoTomado}`);
          break;

        case !error.response && error.request:
          mensajeError = new Error(`No hubo respuesta del servidor ${tiempoTomado}`);
          break;

        default:
          mensajeError = new Error(`Error desconocido: ${error.message} ${tiempoTomado}`);
      }

      return _f_.validarLLamadoApi({
        respuesta: mensajeError,
        endpoint,
        origen,
      });
    }
  }
  let respuesta = llamado();
  return { respuesta, controlLlamado };
}
/*=================================
APIS
===================================*/
export const f_llamarApiDinamica = ({ parametros, timeout = 10000, endpoint = "", origen = "" }) => {
  // console.log(
  //   'parametros',
  //   parametros,
  //   ',endpoint,',
  //   endpoint,
  //   ',timeout',
  //   timeout
  // )
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint,
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_inicioSesion = ({ parametros, parametros: { usuario, contrasenia }, origen = "", timeout }) => {
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "inicioSesion",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_cerrarSesion = ({ parametros, timeout, origen = "" }) => {
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "cerrarSesion",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_validarSesion = ({ origen = "", timeout }) => {
  const peticion = crearPeticion();
  const llamado = llamarApi({
    endpoint: "validarSesion",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_obtenerMenu = ({ origen = "", timeout }) => {
  const peticion = crearPeticion();
  const llamado = llamarApi({ endpoint: "menu", peticion, origen, timeout });
  return llamado;
};

export const f_obtenerInformacionUsuario = ({ origen = "", timeout }) => {
  const peticion = crearPeticion();
  const llamado = llamarApi({
    endpoint: "obtenerInfoUsuario",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_personasCRUD = ({ parametros, parametros: { modo, codigoPersona, persona }, origen = "", timeout }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "personasCRUD",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_productosTerminadosCRUD = ({
  parametros,
  parametros: { modo, codigoUsuario, codigoProducto, codigosProductos, datos },
  origen = "",
  timeout,
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "productoTerminado",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_listaDistribuidores = ({ parametros, origen = "", timeout }) => {
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "listarDistribuidores",
    peticion,
    origen,
    timeout,
  });
  console.log(peticion);
  return llamado;
};

export const f_listarAyudantesDistribuidor = ({
  parametros,
  parametros: { codUsuario }, //codDistribuidor
  origen = "",
  timeout,
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "listarAyudantesDistribuidor",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_obtenerProductos = ({ parametros, parametros: { codUsuario }, origen = "", timeout }) => {
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "obtenerProductosV2",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_pedidoTienda = ({
  parametros,
  parametros: { codUsuario, tipoDistribucion = 1 },
  timeout,
  origen = "",
}) => {
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "ultimoPedidoV2",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_generarPedidoDistribuidor = ({
  parametros,
  parametros: { codUsuario, tipoDistribucion = 2 },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "generarPedidoDistribuidor",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_solicitarPedido = ({
  parametros,
  parametros: {
    codUsuario,
    codPedido,
    pedidooentrega,
    fechaEntregaEstimada,
    comentario,
    tipo_comprobante = null, //para pedido distribuidor
    tipo_documento = null, //para pedido distribuidor
    numero_documento = null, //para pedido distribuidor
    nombre_cliente = null, //para pedido distribuidor
    fechaEntrega = null,
  },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "guardarPedido",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_listarMaestros = ({ parametros, parametros: { empresa, activo }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "listarMaestros",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_listaProductoMaestro = ({
  parametros,
  parametros: { maestro, todo = "S", activo, categoria, extenso, stock = "N" },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "listaProductoMaestrov2",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_estructuraObtenerMaestroPP = ({ parametros, parametros: { codProducto }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "estructuraObtenerMaestrosPP",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_estructuraObtenerProductosTerminadosPP = ({
  parametros,
  parametros: { codProducto },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "estructuraObtenerProductosTerminadosPP",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_detallePedido = ({ parametros, parametros: { codPedido, todo = "S" }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "estructuraDetallePedido",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_listarPedidos = ({
  parametros,
  parametros: { codUsuario, fecha, orden, fecha_filtro },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "pedidos",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_contraseniaRestablecer = ({
  parametros,
  parametros: { modo, codigo, contrasenia, recontrasenia },
  timeout,
  origen = "",
}) => {
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "contraseniaRestablecer",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_restablecerContrasenia = ({ parametros, parametros: { codigoUsuario }, timeout, origen = "" }) => {
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "restablecerContrasenia",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_accesoUsuarioSistema = ({
  parametros,
  parametros: { modo, codigo, habilitado },
  timeout,
  origen = "",
}) => {
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "bloquearUsuario",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_crudComponenteInstalado = ({
  parametros,
  parametros: { modo, codApl, nomApl, tipo, dscApl, habilitado },
  timeout,
  origen = "",
}) => {
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "crudComponenteInstalado",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_crudClasificacion = ({
  parametros,
  parametros: { modo, codClasificacion, dscClasificacion, habilitado, programaorigen },
  timeout,
  origen = "",
}) => {
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "crudClasificacion",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_crudMenu = ({
  parametros,
  parametros: { modo, codigo, dscMenu, esOpcion, codPrograma, codIcono, habilitado },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "crudMenu",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_crudOpcionMenu = ({
  parametros,
  parametros: { modo, codigo, dscOpMenu, codClasificacion, codPrograma, codMenu, habilitado },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "crudOpcionMenu",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_crudMenuRol = ({
  parametros,
  parametros: { modo, codigo, codRol, codMenu, ordVis, habilitado },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "crudMenuRol",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_FormularioProductosProduccion = ({
  parametros,
  parametros: { modo, codigo, form },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "FormularioProductosProduccion",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_FormularioComprobantesVT = ({
  parametros,
  parametros: { tipoComprobante = "T" },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "FormularioComprobantesVT",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_obtenerPersonaDNI = ({ parametros, parametros: { numeroDNI }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "obtenerPersonaDNI",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_obtenerEmpresaRUC = ({ parametros, parametros: { numero_documento }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "obtenerEmpresaRUC",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_estructuraRemate = ({ parametros, parametros: { pedido, editarPedido }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "estructuraRemate",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_estructuraBonificaciones = ({
  parametros,
  parametros: { pedido, editarPedido },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "estructuraBonificacion",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_eliminarPedido = ({ parametros, parametros: { pedido }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "eliminarPedido",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_reportePagosVT = ({ parametros, parametros: { fecha }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "reportePagosVT",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_empresaCrud = ({ parametros, parametros: { modo, codigoEmpresa, empresa }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "empresaCrud",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_marcasCrud = ({ parametros, parametros: { modo, codigo, datosMarca }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "marcasCRUD",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_etapasCRUD = ({ parametros, parametros: { modo, codigo, datos }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "etapasCRUD",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_pdfDespachoPedido = ({
  parametros,
  parametros: { pedido, cuenta = "S o N", entregado = "S o N" },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "pdfDespachoPedido",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_categoriasProductosCRUD = ({
  parametros,
  parametros: { modo, codigo, datos },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "categoriasProductosCRUD",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_RelacionMaestrosPPCRUD = ({
  parametros,
  parametros: { modo, codigoMaestro, codigoPP, datos },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "RelacionMaestrosPPCRUD",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_RelacionPTPPCRUD = ({
  parametros,
  parametros: { modo, codigoPT, codigoPP, datos },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "RelacionPTPPCRUD",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_estructuraGenerarPedidoProduccion = ({
  parametros,
  parametros: { modo, codigoPT, codigoPP, datos },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "estructuraGenerarPedidoProduccion",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_GenerarPedidoMaestroCRUD = ({ parametros, parametros: { modo, datos }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "GenerarPedidoMaestroCRUD",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_editarIngresoProductoMaestro = ({
  parametros,
  parametros: { produccion, cantidad, funcion = 1, producto, comentario = null },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "editarIngresoProductoMaestro",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_reportePedidoProduccionDiario = ({ parametros, parametros: { fecha }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "reportePedidoProduccionDiario",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_estructuraListaProducciones = ({
  parametros,
  parametros: { fecha_inicio, fecha_fin },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "estructuraListaProducciones",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_guardarIngresoProductoMaestro = ({
  parametros,
  parametros: { produccion = null, fecProduccion, funcion = 1 },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "guardarIngresoProductoMaestro",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_estructuraDetalleProduccion = ({
  parametros,
  parametros: { produccion = null, todo = "N", editarPedido = "N", editarEntrega = "N" },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "estructuraDetalleProduccion",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};
//RelacionEmpaquetadoraPT
// export const f_RelacionEmpaquetadoraPT = ({
//   parametros,
//   parametros: { modo, codProducto,datos},
//   timeout,
//   origen = "",
// }) => {
//   console.log(parametros);
//   const peticion = crearPeticion(parametros);
//   const llamado = llamarApi({
//     endpoint: "RelacionEmpaquetadoraPT",
//     peticion,
//     origen,
//     timeout,
//   });
//   return llamado;
// };
//RelacionEtapasPT
export const f_RelacionEtapasPT = ({ parametros, parametros: { modo, codProducto, datos }, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "RelacionEtapasPT",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_estructuraStockProductoTerminado = ({
  parametros,
  parametros: { codUsuario, incrementoActualizacion },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "estructuraStockProductoTerminado",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

//RelacionEmpaquetadoraEtapaPT
export const f_RelacionEmpaquetadoraEtapaPT = ({
  parametros,
  parametros: { modo, codEmpaquetador, codEtapa, datos },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "RelacionEmpaquetadoraEtapaPT",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_estructuraStockProduccion = ({ parametros, parametros: {}, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "estructuraStockProduccion",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

//
export const f_boletas_facturas = ({
  parametros,
  parametros: { fecha_inicio, fecha_fin, empresa, tipo_comprobantes },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "boletas_facturas",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_listarEmpresas = ({
  parametros,
  parametros: { codigo = null, activo = "S", propietaria = "S" },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "listarEmpresas",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_obtenerDocumentoComprobantes = ({
  parametros,
  parametros: { codigo = null, tipo_documento = "", empresa = "" },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "obtenerDocumentoComprobantes",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_guardarStock = ({ parametros, parametros: {}, timeout, origen = "" }) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "guardarStock",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};

export const f_estructuraPedidosEmbolsado = ({
  parametros,
  parametros: { fecha_inicio, fecha_fin },
  timeout,
  origen = "",
}) => {
  console.log(parametros);
  const peticion = crearPeticion(parametros);
  const llamado = llamarApi({
    endpoint: "estructuraPedidosEmbolsado",
    peticion,
    origen,
    timeout,
  });
  return llamado;
};
